var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaceRecognitioninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#face-recognition_inline_svg__clip0)",
    fill: "#0F0449"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.53 22.961c-.29-.108-.59-.217-.894-.333a.208.208 0 01-.136-.192v-1.77a.209.209 0 01.07-.155 3.539 3.539 0 001.17-2.384c.223-.216.372-.496.427-.8a1.839 1.839 0 00-.346-1.699c.021-.057.049-.122.077-.194a6.908 6.908 0 00.679-3.48c-.278-1.38-2.225-1.913-3.809-1.954-1.366-.028-3.042.274-3.556 1.215a1.571 1.571 0 00-1.142.618c-.724.976-.198 2.71.083 3.64.015.053.03.1.043.14a1.828 1.828 0 00-.363 1.713c.054.305.203.586.425.802a3.54 3.54 0 001.171 2.384.208.208 0 01.071.154v1.769a.208.208 0 01-.136.195l-.896.333c-2.891 1.063-4.98 1.833-5.59 3.055A8.807 8.807 0 0010 29.583a.417.417 0 00.417.417h19.166a.417.417 0 00.417-.417 8.804 8.804 0 00-.878-3.567c-.611-1.225-2.7-1.992-5.591-3.055zM10.833 14.167a.833.833 0 00.834-.834v-1.25a.417.417 0 01.416-.416h1.25a.833.833 0 000-1.667h-1.666A1.666 1.666 0 0010 11.667v1.666a.833.833 0 00.833.834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 22.5h1.666a.833.833 0 000-1.667h-1.25a.417.417 0 01-.416-.417v-1.25a.833.833 0 00-1.667 0v1.667a1.666 1.666 0 001.667 1.667zM28.334 10h-1.667a.833.833 0 100 1.667h1.25a.417.417 0 01.417.416v1.25a.833.833 0 001.667 0v-1.666A1.666 1.666 0 0028.334 10zM29.167 18.333a.833.833 0 00-.833.833v1.25a.417.417 0 01-.417.417h-1.25a.833.833 0 100 1.667h1.667a1.667 1.667 0 001.667-1.667v-1.667a.833.833 0 00-.834-.833z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "face-recognition_inline_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgFaceRecognitioninline;